import { useQuery, useQueryClient } from '@tanstack/react-query'

import { LayoutReactQueryKeys } from '../../types'

const SEARCH_IMPRESSION_QUERY_KEY = [LayoutReactQueryKeys.SearchImpressionSeenIds]

const getInitialSeenIds = (): Set<string | number> => {
    return new Set()
}

export const useSearchImpression = () => {
    const queryClient = useQueryClient()

    const { data: seenIds = new Set() } = useQuery<Set<string | number>>({
        queryKey: SEARCH_IMPRESSION_QUERY_KEY,
        queryFn: () => getInitialSeenIds(),
        staleTime: Infinity,
        refetchOnWindowFocus: false,
    })

    const markAsSeen = (id: string | number | undefined) => {
        if (!id) return

        queryClient.setQueryData<Set<string | number>>(SEARCH_IMPRESSION_QUERY_KEY, (old) => {
            const newSet = old ? new Set<string | number>(old) : new Set<string | number>()
            newSet.add(id)
            return newSet
        })
    }

    const resetImpressions = () => {
        queryClient.setQueryData<Set<string | number>>(SEARCH_IMPRESSION_QUERY_KEY, new Set())
    }

    return {
        seenIds,
        markAsSeen,
        resetImpressions,
    }
}
